import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {TopManagementComponent} from './top-management.component';
import {CreateTmComponent} from './create-tm/create-tm.component';
import {ListStrategyActionsComponent} from './list-strategy-actions/list-strategy-actions.component';
import {ViewTmPostComponent} from './view-tm-post/view-tm-post.component';
import {EditTmComponent} from './edit-tm/edit-tm.component';
import {ListProfitabilityComponent} from './list-profitability/list-profitability.component';
import {ListCompetitionComponent} from './list-competition/list-competition.component';
import {ListDevelopmentOpportunitiesComponent} from './list-development-opportunities/list-development-opportunities.component';
import {ListOthersComponent} from './list-others/list-others.component';


const topManagementRoute: Routes = [
    {
        path: '',
        component: TopManagementComponent,
        children: [
            {
                path: 'adauga-tm',
                component: CreateTmComponent
            },
            {
                path: 'postare/:id',
                component: ViewTmPostComponent
            },
            {
                path: 'editare-tm/:id',
                component: EditTmComponent
            },
            {
                path: 'actiuni-strategice',
                component: ListStrategyActionsComponent
            },
            {
                path: 'profitabilitate',
                component: ListProfitabilityComponent
            },
            {
                path: 'concurenta',
                component: ListCompetitionComponent
            },
            {
                path: 'oportunitati-de-dezvoltare',
                component: ListDevelopmentOpportunitiesComponent
            },
            {
                path: 'alte',
                component: ListOthersComponent
            },
            { path: '', redirectTo: '/', pathMatch: 'full' },
            {
                path: '**',
                redirectTo: '/',
                pathMatch: 'full',
            }
        ]
    }
]

@NgModule({
    imports: [RouterModule.forChild(topManagementRoute)],
    exports: [RouterModule]
})
export class TopManagementRoutingModule {
}
